export class IsiPostbackTransaction {

    IsiEvents: any[];

    constructor() {
        // <summary>
        // Objet représentant une transaction de repostage
        // </summary>
        this.IsiEvents = new Array();
    }

    addEvent(args) {
        // <summary>
        // Permet d'ajouter un évènement composant (qui sera traité par le controlleur> dans la transaction 
        // </summary>
        // <param name="args">Les arguments de l'évènement</param>
        this.IsiEvents[this.IsiEvents.length] = args;
    }
};